import { render, staticRenderFns } from "./ReviewSubmit.vue?vue&type=template&id=1bd3d71e&scoped=true&"
import script from "./ReviewSubmit.vue?vue&type=script&lang=js&"
export * from "./ReviewSubmit.vue?vue&type=script&lang=js&"
import style0 from "./ReviewSubmit.vue?vue&type=style&index=0&id=1bd3d71e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd3d71e",
  null
  
)

export default component.exports